import { SHIPMENT_CARD_MARGIN_BOTTOM } from '@/modules/pmt/constants';
import { motion } from 'framer-motion';
import styled from 'styled-components';

export const AnimateListWrapper = styled(motion.div)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing[SHIPMENT_CARD_MARGIN_BOTTOM],
}));
